export enum CultureIso {
    Bulgarian = 'bg-BG',
    Croatian = 'hr-HR',
    Czech = 'cs-CZ',
    Danish = 'da-DK',
    Deutsch = 'de-DE',
    Dutch = 'nl-NL',
    English = 'en-GB',
    Finnish = 'fi-FI',
    French = 'fr-FR',
    Italian = 'it-IT',
    Greek = 'el-GR',
    Hungarian = 'hu-HU',
    Norwegian = 'nb-NO',
    Polish = 'pl-PL',
    Portuguese = 'pt-PT',
    Romanian = 'ro-RO',
    Spanish = 'es-ES',
    Swedish = 'sv-SE',
    Slovenian = 'sl-SI',
    Slovak = 'sk-SK',
    Latvian = 'lv-LV',
    Lithuanian = 'lt-LT',
    Estonian = 'et-EE'
}
